import { render, staticRenderFns } from "./SfProperty.vue?vue&type=template&id=3978c43e&functional=true"
import script from "./SfProperty.vue?vue&type=script&lang=js"
export * from "./SfProperty.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfProperty.vue?vue&type=style&index=0&id=3978c43e&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "1f291b07"
  
)

export default component.exports